<template>
  <div class="vendor-card-image">
    <img ref="img" v-image-fall-back="vendorImgFallback" :src="imageUrl" class="logo" alt="Logo" />
    <div v-if="!isOpen" class="iw-item-description vendor-card-banner">
      <span class="vendor-card-banner__shape"><p>!</p></span>
      <svg class="vendor-card-banner__image svg-inline--fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M11.999 6.02l-.003 5.246c0 .2.08.39.22.53l3.754 3.754 1.06-1.06-3.534-3.534.002-4.937h-1.5z"
          transform="translate(0 2)"
        />
        <path
          fill="currentColor"
          d="M13.5.02c-5.28 0-9.648 3.92-10.38 9H0l3.75 3.75L7.5 9.02H4.635c.718-4.25 4.414-7.5 8.865-7.5 4.963 0 9 4.036 9 9 0 4.962-4.037 9-9 9-2.79 0-5.377-1.263-7.097-3.465l-1.182.923c2.007 2.568 5.024 4.041 8.279 4.041 5.79 0 10.5-4.71 10.5-10.5C24 4.73 19.29.02 13.5.02z"
          transform="translate(0 2)"
        />
      </svg>
      <span class="vendor-card-banner__close">Currently Closed</span>
    </div>
  </div>
</template>

<script>
import IMG_FALLBACK from "@/assets/images/vendor_missing.svg";

export default {
  name: "VendorImage",
  props: {
    imageUrl: String,
    vendorAlias: String,
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      vendorImgFallback: IMG_FALLBACK
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.vendor-card-image {
  position: relative;
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
    border-radius: 2px;
    height: 137px;
    @include respond-to-mobile {
      width: 100%;
    }
  }
}
.vendor-card-image::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 3px;
  left: 0;
  right: 0;
  border-radius: 2px;
  box-shadow: inset 1px -57px 46px -38px rgba(0, 0, 0, 0.6);
  transition: box-shadow 0.2s ease-in;
}

.vendor-card-banner {
  position: absolute;
  bottom: 17px;
  left: 17px;
  right: auto;
  color: $group-1-color-2;
  text-align: center;
  vertical-align: middle;
  letter-spacing: normal;

  &__image {
    width: 17px;
    height: 17px;
    color: $group-1-color-2;
    margin: 0px 4px -4px 0px;
  }
  &__shape {
    width: 10px;
    height: 10px;
    position: absolute;
    border-radius: 50%;
    background-color: $group-4-color-1;
    margin: 6px 0px 0px -2px;
    p {
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      margin: -2.5px 0px 0px -1px;
    }
  }
}
</style>
